'use strict';

exports.__esModule = true;
exports.reducer = reducer;
var FIXED = {
  playersById: {
    'washington-diego-cavanagh': {
      name: 'Diego Cavanagh',
      number: 1,
      photo: '/teams/washington/diego-cavanagh.jpg',
      handicap: 8,
      titlesByTournamentId: {
        'tortugas': 0,
        'hurlingham': 0,
        'palermo': 0
      },
      tripleCrownTitles: 0
    },
    'washington-ezequiel-martinez-ferrario': {
      name: 'Ezequiel Martinez Ferrario',
      number: 2,
      photo: '/teams/washington/ezequiel-martinez-ferrario.jpg',
      handicap: 7,
      titlesByTournamentId: {
        'tortugas': 0,
        'hurlingham': 0,
        'palermo': 0
      },
      tripleCrownTitles: 0
    },
    'washington-facundo-sola': {
      name: 'Facundo Sola',
      number: 3,
      photo: '/teams/washington/facundo-sola.jpg',
      handicap: 8,
      titlesByTournamentId: {
        'tortugas': 0,
        'hurlingham': 0,
        'palermo': 0
      },
      tripleCrownTitles: 0
    },
    'washington-alfredo-cappella-barabucci': {
      name: 'Alfredo Cappella Barabucci',
      number: 4,
      photo: '/teams/washington/alfredo-cappella-barabucci.jpg',
      handicap: 8,
      titlesByTournamentId: {
        'tortugas': 0,
        'hurlingham': 0,
        'palermo': 0
      },
      tripleCrownTitles: 0
    },
    'magual-alejandro-muzzio': {
      name: 'Alejandro Muzzio',
      number: 1,
      photo: '/teams/magual/alejandro-muzzio.jpg',
      handicap: 8,
      titlesByTournamentId: {
        'tortugas': 0,
        'hurlingham': 0,
        'palermo': 0
      },
      tripleCrownTitles: 0
    },
    'magual-francisco-elizalde': {
      name: 'Francisco Elizalde',
      number: 2,
      photo: '/teams/magual/francisco-elizalde.jpg',
      handicap: 7,
      titlesByTournamentId: {
        'tortugas': 0,
        'hurlingham': 0,
        'palermo': 0
      },
      tripleCrownTitles: 0
    },
    'magual-marcos-di-paola': {
      name: 'Marcos Di Paola',
      number: 3,
      photo: '/teams/magual/marcos-di-paola.jpg',
      handicap: 8,
      titlesByTournamentId: {
        'tortugas': 0,
        'hurlingham': 0,
        'palermo': 0
      },
      tripleCrownTitles: 0
    },
    'magual-santiago-toccalino': {
      name: 'Santiago Toccalino',
      number: 4,
      photo: '/teams/magual/santiago-toccalino.jpg',
      handicap: 8,
      titlesByTournamentId: {
        'tortugas': 0,
        'hurlingham': 0,
        'palermo': 0
      },
      tripleCrownTitles: 0
    },
    'alegria-cristian-laprida': {
      name: 'Cristian Laprida (h)',
      number: 1,
      photo: '/teams/alegria/cristian-laprida.jpg',
      handicap: 8,
      titlesByTournamentId: {
        'tortugas': 0,
        'hurlingham': 0,
        'palermo': 0
      },
      tripleCrownTitles: 0
    },
    'alegria-hilario-ulloa': {
      name: 'Hilario Ulloa',
      number: 2,
      photo: '/teams/alegria/hilario-ulloa.jpg',
      handicap: 9,
      titlesByTournamentId: {
        'tortugas': 0,
        'hurlingham': 0,
        'palermo': 0
      },
      tripleCrownTitles: 0
    },
    'alegria-lucas-monteverde': {
      name: 'Lucas Monteverde (h)',
      number: 3,
      photo: '/teams/alegria/lucas-monteverde.jpg',
      handicap: 9,
      titlesByTournamentId: {
        'tortugas': 0,
        'hurlingham': 1,
        'palermo': 4
      },
      tripleCrownTitles: 5
    },
    'alegria-frederick-mannix': {
      name: 'Frederick Mannix (h)',
      number: 4,
      photo: '/teams/alegria/frederick-mannix.jpg',
      handicap: 9,
      titlesByTournamentId: {
        'tortugas': 0,
        'hurlingham': 0,
        'palermo': 0
      },
      tripleCrownTitles: 0
    },
    'la-aguada-agustin-merlos': {
      name: 'Agustín Merlos',
      number: 1,
      photo: '/teams/la-aguada/agustin-merlos.jpg',
      handicap: 8,
      titlesByTournamentId: {
        'tortugas': 0,
        'hurlingham': 0,
        'palermo': 0
      },
      tripleCrownTitles: 0
    },
    'la-aguada-guillermo-terrera': {
      name: 'Guillermo Terrera (h)',
      number: 2,
      photo: '/teams/la-aguada/guillermo-terrera.jpg',
      handicap: 8,
      titlesByTournamentId: {
        'tortugas': 0,
        'hurlingham': 0,
        'palermo': 0
      },
      tripleCrownTitles: 0
    },
    'la-aguada-guillermo-caset': {
      name: 'Guillermo Caset (h)',
      number: 3,
      photo: '/teams/la-aguada/guillermo-caset.jpg',
      handicap: 9,
      titlesByTournamentId: {
        'tortugas': 0,
        'hurlingham': 0,
        'palermo': 0
      },
      tripleCrownTitles: 0
    },
    'la-aguada-ignacio-novillo-astrada': {
      name: 'Ignacio Novillo Astrada (h)',
      number: 4,
      photo: '/teams/la-aguada/ignacio-novillo-astrada.jpg',
      handicap: 9,
      titlesByTournamentId: {
        'tortugas': 2,
        'hurlingham': 2,
        'palermo': 1
      },
      tripleCrownTitles: 5
    },
    'la-dolfina-adolfo-cambiaso': {
      name: 'Adolfo Cambiaso (h)',
      number: 1,
      photo: '/teams/la-dolfina/adolfo-cambiaso.jpg',
      handicap: 10,
      titlesByTournamentId: {
        'tortugas': 6,
        'hurlingham': 12,
        'palermo': 11
      },
      tripleCrownTitles: 29
    },
    'la-dolfina-david-stirling': {
      name: 'David Stirling (h)',
      number: 2,
      photo: '/teams/la-dolfina/david-stirling.jpg',
      handicap: 10,
      titlesByTournamentId: {
        'tortugas': 3,
        'hurlingham': 5,
        'palermo': 3
      },
      tripleCrownTitles: 11
    },
    'la-dolfina-pablo-mac-donough': {
      name: 'Pablo Mac Donough',
      number: 3,
      photo: '/teams/la-dolfina/pablo-mac-donough.jpg',
      handicap: 10,
      titlesByTournamentId: {
        'tortugas': 8,
        'hurlingham': 9,
        'palermo': 5
      },
      tripleCrownTitles: 22
    },
    'la-dolfina-juan-martin-nero': {
      name: 'Juan Martin Nero',
      number: 4,
      photo: '/teams/la-dolfina/juan-martin-nero.jpg',
      handicap: 10,
      titlesByTournamentId: {
        'tortugas': 6,
        'hurlingham': 7,
        'palermo': 5
      },
      tripleCrownTitles: 18
    },
    'las-monjitas-ignacio-toccalino': {
      name: 'Ignacio Toccalino',
      number: 1,
      photo: '/teams/las-monjitas/ignacio-toccalino.jpg',
      handicap: 9,
      titlesByTournamentId: {
        'tortugas': 0,
        'hurlingham': 0,
        'palermo': 0
      },
      tripleCrownTitles: 0
    },
    'las-monjitas-sebastian-merlos': {
      name: 'Sebastián Merlos',
      number: 2,
      photo: '/teams/las-monjitas/sebastian-merlos.jpg',
      handicap: 9,
      titlesByTournamentId: {
        'tortugas': 1,
        'hurlingham': 4,
        'palermo': 2
      },
      tripleCrownTitles: 7
    },
    'las-monjitas-eduardo-novillo-astrada': {
      name: 'Eduardo Novillo Astrada (h)',
      number: 3,
      photo: '/teams/las-monjitas/eduardo-novillo-astrada.jpg',
      handicap: 9,
      titlesByTournamentId: {
        'tortugas': 3,
        'hurlingham': 2,
        'palermo': 1
      },
      tripleCrownTitles: 6
    },
    'las-monjitas-alejandro-novillo-astrada': {
      name: 'Alejandro Novillo Astrada',
      number: 4,
      photo: '/teams/las-monjitas/alejandro-novillo-astrada.jpg',
      handicap: 8,
      titlesByTournamentId: {
        'tortugas': 0,
        'hurlingham': 0,
        'palermo': 0
      },
      tripleCrownTitles: 0
    },
    'ellerstina-pablo-pieres': {
      name: 'Pablo Pieres',
      number: 1,
      photo: '/teams/ellerstina/pablo-pieres.jpg',
      handicap: 10,
      titlesByTournamentId: {
        'tortugas': 0,
        'hurlingham': 0,
        'palermo': 0
      },
      tripleCrownTitles: 0
    },
    'ellerstina-nicolas-pieres': {
      name: 'Nicolas Pieres',
      number: 2,
      photo: '/teams/ellerstina/nicolas-pieres.jpg',
      handicap: 9,
      titlesByTournamentId: {
        'tortugas': 2,
        'hurlingham': 0,
        'palermo': 1
      },
      tripleCrownTitles: 3
    },
    'ellerstina-gonzalo-pieres': {
      name: 'Gonzalo Pieres (h)',
      number: 3,
      photo: '/teams/ellerstina/gonzalo-pieres.jpg',
      handicap: 10,
      titlesByTournamentId: {
        'tortugas': 7,
        'hurlingham': 4,
        'palermo': 3
      },
      tripleCrownTitles: 14
    },
    'ellerstina-facundo-pieres': {
      name: 'Facundo Pieres',
      number: 4,
      photo: '/teams/ellerstina/facundo-pieres.jpg',
      handicap: 10,
      titlesByTournamentId: {
        'tortugas': 7,
        'hurlingham': 4,
        'palermo': 3
      },
      tripleCrownTitles: 14
    },
    'chapaleufu-alberto-heguy': {
      name: 'Alberto Heguy (h)',
      number: 1,
      photo: '/teams/chapaleufu/alberto-heguy.jpg',
      handicap: 8,
      titlesByTournamentId: {
        'tortugas': 7,
        'hurlingham': 3,
        'palermo': 4
      },
      tripleCrownTitles: 14
    },
    'chapaleufu-ignacio-heguy': {
      name: 'Ignacio Heguy',
      number: 2,
      photo: '/teams/chapaleufu/ignacio-heguy.jpg',
      handicap: 9,
      titlesByTournamentId: {
        'tortugas': 5,
        'hurlingham': 1,
        'palermo': 4
      },
      tripleCrownTitles: 10
    },
    'chapaleufu-bautista-heguy': {
      name: 'Bautista Heguy',
      number: 3,
      photo: '/teams/chapaleufu/bautista-heguy.jpg',
      handicap: 8,
      titlesByTournamentId: {
        'tortugas': 1,
        'hurlingham': 4,
        'palermo': 5
      },
      tripleCrownTitles: 10
    },
    'chapaleufu-eduardo-heguy': {
      name: 'Eduardo Heguy',
      number: 4,
      photo: '/teams/chapaleufu/eduardo-heguy.jpg',
      handicap: 9,
      titlesByTournamentId: {
        'tortugas': 8,
        'hurlingham': 3,
        'palermo': 4
      },
      tripleCrownTitles: 15
    }
  },
  byId: {
    'washington': {
      colour: 'CLARET',
      id: 'washington',
      images: {
        card: '/teams/washington/card.jpg',
        logo: '/teams/washington/logo.jpg'
      },
      name: 'Washington',
      players: ['washington-diego-cavanagh', 'washington-ezequiel-martinez-ferrario', 'washington-facundo-sola', 'washington-alfredo-cappella-barabucci'],
      handicap: 31,
      titlesByTournamentId: {
        'tortugas': 0,
        'hurlingham': 0,
        'palermo': 0
      },
      tripleCrownTitles: 0
    },
    'magual': {
      colour: 'CLARET',
      id: 'magual',
      images: {
        card: '/teams/magual/card.jpg',
        logo: '/teams/magual/logo.jpg'
      },
      name: 'Magual',
      players: ['magual-alejandro-muzzio', 'magual-francisco-elizalde', 'magual-marcos-di-paola', 'magual-santiago-toccalino'],
      handicap: 31,
      titlesByTournamentId: {
        'tortugas': 0,
        'hurlingham': 0,
        'palermo': 0
      },
      tripleCrownTitles: 0
    },
    'la-aguada': {
      colour: 'CLARET',
      id: 'la-aguada',
      images: {
        card: '/teams/la-aguada/card.jpg',
        logo: '/teams/la-aguada/logo.jpg'
      },
      name: 'La Aguada',
      players: ['la-aguada-agustin-merlos', 'la-aguada-guillermo-terrera', 'la-aguada-guillermo-caset', 'la-aguada-ignacio-novillo-astrada'],
      handicap: 34,
      titlesByTournamentId: {
        'tortugas': 2,
        'hurlingham': 3,
        'palermo': 1
      },
      tripleCrownTitles: 6
    },
    'las-monjitas': {
      colour: 'ORANGE',
      id: 'las-monjitas',
      images: {
        card: '/teams/las-monjitas/card.jpg',
        logo: '/teams/las-monjitas/logo.jpg'
      },
      name: 'Las Monjitas',
      players: ['las-monjitas-ignacio-toccalino', 'las-monjitas-sebastian-merlos', 'las-monjitas-eduardo-novillo-astrada', 'las-monjitas-alejandro-novillo-astrada'],
      handicap: 35,
      titlesByTournamentId: {
        'tortugas': 0,
        'hurlingham': 0,
        'palermo': 0
      },
      tripleCrownTitles: 0
    },
    'ellerstina': {
      colour: 'DARK_GREY',
      id: 'ellerstina',
      images: {
        card: '/teams/ellerstina/card.jpg',
        logo: '/teams/ellerstina/logo.jpg'
      },
      name: 'Ellerstina',
      players: ['ellerstina-pablo-pieres', 'ellerstina-nicolas-pieres', 'ellerstina-gonzalo-pieres', 'ellerstina-facundo-pieres'],
      handicap: 39,
      titlesByTournamentId: {
        'tortugas': 10,
        'hurlingham': 7,
        'palermo': 6
      },
      tripleCrownTitles: 23
    },
    'chapaleufu': {
      colour: 'RED',
      id: 'chapaleufu',
      images: {
        card: '/teams/chapaleufu/card.jpg',
        logo: '/teams/chapaleufu/logo.jpg'
      },
      name: 'Chapaleufú',
      players: ['chapaleufu-alberto-heguy', 'chapaleufu-ignacio-heguy', 'chapaleufu-bautista-heguy', 'chapaleufu-eduardo-heguy'],
      handicap: 34,
      titlesByTournamentId: {
        'tortugas': 8,
        'hurlingham': 6,
        'palermo': 10
      },
      tripleCrownTitles: 24
    },
    'alegria': {
      colour: 'PURPLE',
      id: 'alegria',
      images: {
        card: '/teams/alegria/card.jpg',
        logo: '/teams/alegria/logo.jpg'
      },
      name: 'Alegría',
      players: ['alegria-cristian-laprida', 'alegria-hilario-ulloa', 'alegria-lucas-monteverde', 'alegria-frederick-mannix'],
      handicap: 35,
      titlesByTournamentId: {
        'tortugas': 0,
        'hurlingham': 0,
        'palermo': 0
      },
      tripleCrownTitles: 0
    },
    'la-dolfina': {
      colour: 'DARK_BLUE',
      id: 'la-dolfina',
      images: {
        card: '/teams/la-dolfina/card.jpg',
        logo: '/teams/la-dolfina/logo.jpg'
      },
      name: 'La Dolfina',
      players: ['la-dolfina-adolfo-cambiaso', 'la-dolfina-david-stirling', 'la-dolfina-pablo-mac-donough', 'la-dolfina-juan-martin-nero'],
      handicap: 40,
      titlesByTournamentId: {
        'tortugas': 3,
        'hurlingham': 9,
        'palermo': 8
      },
      tripleCrownTitles: 19
    }
  }
};

function reducer(state, action) {
  if (state === undefined) state = FIXED;

  return state;
}